import Link from 'next/link';

import { SidebarNavigationItem } from '@air/component-sidebar-navigation';
import { TagIcon } from '@air/design-icons';

import { Routes } from '~/constants/routes';
import { useIsActiveRoute } from '~/hooks/useIsActiveRoute';

export const SidebarNavigationItemUntaggedItems = () => {
  const { isActiveRoute } = useIsActiveRoute({ route: Routes.media.untaggedItems });

  return (
    <SidebarNavigationItem
      asChild
      data-id="untagged-items"
      prefix={<TagIcon size="sm" />}
      state={isActiveRoute ? 'active' : 'default'}
    >
      <Link href={Routes.media.all}>Untagged items</Link>
    </SidebarNavigationItem>
  );
};
